import { RouteRecordRaw } from 'vue-router';

const router: Array<RouteRecordRaw> = [
  {
    path: '/Student',
    name: 'student',
    component: () => import(/* webpackChunkName: "Student" */ '@/views/Student/index.vue'),
    children: [
      {
        path: '/Student/home',
        name: 'student-home',
        component: () => import(/* webpackChunkName: "student_home" */ '@/views/Student/homepage/index.vue'),
        meta: {
          title: '学生首页',
          icon: '',
          role: ['student'],
        },
      },
      {
        path: '/Student/userInfo',
        name: 'Student/UserInfo',
        component: () => import(/* webpackChunkName: "StudentUserInfo" */ '../../views/Public/UserInfo.vue'),
        meta: {
          title: '个人中心',
          icon: '',
          role: ['admin', 'teacher', 'student'],
        },
      },
      {
        path: '/Student/report',
        name: 'student-report',
        component: () => import(/* webpackChunkName: "student_report" */ '@/views/Student/reportManage/index.vue'),
        meta: {
          title: '实验报告',
          icon: '',
          role: ['student'],
        },
      },
      {
        path: '/Student/reportInfo/:id?',
        name: 'student-report-info',
        component: () => import(/* webpackChunkName: "student_report_info" */ '@/views/Student/reportManage/reportInfo.vue'),
        meta: {
          title: '报告详情',
          icon: '',
          role: ['student'],
        },
      },
      {
        path: '/Student/analysis',
        name: 'student-analysis',
        component: () => import(/* webpackChunkName: "student_analysis" */ '@/views/Student/analysis/index.vue'),
        meta: {
          title: '案例分析',
          icon: '',
          role: ['student'],
        },
      },
      {
        path: '/Student/analysisAnswer',
        name: 'student-analysis-answer',
        component: () => import(/* webpackChunkName: "student_analysis_answer" */ '@/views/Student/analysis/analysisAnswer.vue'),
        meta: {
          title: '作业答题',
          icon: '',
          role: ['student'],
        },
        /**
         * 案例分析-分析页面——全局查询锚点
         * view: 'submit', // preview,see,submit —— required
         * jobId: record.assignmentId, // jobId这是教师端的作业id —— required
         * assignmentId: record.id, // 这是分配表的id —— 查询学生做的纪录需要
         * assignmentModel: record.assignmentModel, // 分配模式 —— 学生做题需要
         * stuCode: record.userId, // 查询指定学生的code —— 只有教师端批改才需要
         */
      },
      {
        path: '/Student/scoreRanking',
        name: 'student-score-ranking',
        component: () => import(/* webpackChunkName: "student_score_ranking" */ '@/views/Student/scoreRanking/index.vue'),
        meta: {
          title: '成绩排名',
          icon: '',
          role: ['student'],
        },
      },
      {
        path: '/Student/resourceDownload',
        name: 'student-resource-download',
        component: () => import(/* webpackChunkName: "student_resource_download" */ '@/views/Student/resourceDownload/index.vue'),
        meta: {
          title: '成绩排名',
          icon: '',
          role: ['student'],
        },
      },
    ],
  },
];

export default router;
